<template>
    <div class="form-container">
        <div class="painel">
            <img src="@/assets/imolgaro.png" width="250px">

            <h1 style="margin-top: 40px;">SG-SIM</h1>
            <h2 style="margin-top: 40px;">ÍTEM AGUARDANDO IMPLEMENTAÇÃO</h2>
        </div>
    </div>    
    
</template>

<style scoped>
.form-container{
    display: flex;
    justify-content: center;
    align-items: center;
}

.painel{
    border-color: #7c8a6e;
    border-style: solid;
    border-radius: 5%;
    border-width: 4px;
    max-width: 600px;
    width: 100%;
    padding: 40px;
    background: #f2eef2;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

h1,h2{
    color: navy;
}
</style>